module.exports = __webpack_public_path__ + "static/favicon-6c47167acc2b78af0d810f6c2828f415.ico";